import { Injectable } from '@angular/core';
import { HttpInterceptorService } from './http-interceptor.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { TranslateService } from '@ngx-translate/core';
import { IspmHttpClient } from '@ispm/core/services/ispm-http-client';
import { Observable } from 'rxjs/Observable';
import { UserActionCreatorService } from '@ispm/user/services/user-action-creator.service';
import {filter} from "rxjs/operators";
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/publish';

@Injectable()
export class TranslationHandlerService {
  public static readonly defaultLang: string = 'en-US';
  static TranslationSuffix = '/translation';
  public static dictionary: any = null;
  public static dictionaryStream: BehaviorSubject<any> = new BehaviorSubject(null);
  private requestMap = new Map();

  private static orgLoaded: boolean;

  public static getDictionary() {
    return this.dictionaryStream
      .asObservable()
      .filter(dict => !!dict);
  }


  constructor(private _http: HttpInterceptorService,
    private _translator: TranslateService,
    private _ispmHttpClient: IspmHttpClient,
    private _getOrgDetails: UserActionCreatorService) {

    this._getOrgDetails.getStoredOrganizationConfiguration().pipe(filter(org => !!org)).subscribe((orgDetails) => {
      if (orgDetails && orgDetails.language && orgDetails.language.code) {
        this.queryDictionary(orgDetails.language.code);
      } else {
        this._translator.setDefaultLang(TranslationHandlerService.defaultLang);
        this.queryDictionary(TranslationHandlerService.defaultLang);
      }
    });
  }

  // Set the language and dictionary
  public queryDictionary(language: string, fromJs = false) {
    if (this.requestMap.has(language) && (!fromJs)) {
      return this.requestMap.get(language);
    } else {
      const translationReq = this._http.get(TranslationHandlerService.TranslationSuffix, { lang: `${language}`})
        .catch(function (error) {
          TranslationHandlerService.dictionary = null;
          return Observable.throw(error);
        })
        .map((dictionary) => {
          this._translator.use(language);
          this.setDictionary(language, dictionary.body.response.content);
          return dictionary;
        })
        .share()
        .publish();
      if(fromJs) {
        return translationReq.toPromise();
      }
      translationReq.connect();
      this.requestMap.set(language, translationReq);
      return translationReq;
    }
  }

  // Get supported  languages list
  public getLangs(): Observable<any> {
    const languagesArray = [];
    return this._ispmHttpClient.get('translation/languages')
      .catch(function (error) {
        TranslationHandlerService.dictionary = null;
        return Observable.throw(error);
      })
      .map((dictionary) => {
        for (let dictionaryKey = 0; dictionaryKey < dictionary.length; dictionaryKey++) {
          if (dictionary[dictionaryKey].resource.language) {
            languagesArray.push(dictionary[dictionaryKey].resource.language);
          }
        }
        return languagesArray;
      });
  }

  public setDictionary(lang: string, dictionary: any) {
    TranslationHandlerService.dictionary = dictionary;
    TranslationHandlerService.dictionaryStream.next(dictionary);
    this._translator.setTranslation(lang, dictionary);
  }

  public getDictionary(language: string): any {
    return this._http.get(TranslationHandlerService.TranslationSuffix, { lang: `${language}`})
    .map((dictionary) => {
      return dictionary;
    });
  }

  public setLang(lang:string) {
    this._translator.use(lang);
  }

  public setOrgLoaded(loaded:boolean) {
    TranslationHandlerService.orgLoaded = loaded ;
  }

  public getOrgLoaded() {
    return TranslationHandlerService.orgLoaded;
  }

}


